import { wrapCall, callPut, callDelete } from './helpers'

type EventPatch = {
  content: { body: string | null }
  tags: string[]
}

type ReactionEvent = {
  reactions: string
}

type EventResponse = {
  id: string
  sessionId?: string
  userId?: string
  stamp: string
  action: 'join' | 'part' | 'chat' | 'sms'
  action_type: 'join' | 'part' | 'chat' | 'sms'
  content: {
    user: APISimpleUser
    title: string | null
    body: string | null
    media: Media[]
    meta: {
      read_by: string[]
      body_history: { stamp: string; content: string }[]
    }
  }
  tags: string[]
}

// Edits a message
export const putPatch = async (id: string, data: EventPatch) => {
  return (await wrapCall({
    method: callPut,
    uri: `/events/${id}`,
    data: { ...data, action_type: 'chat' }
  })) as EventResponse
}

// Reacts to a message
export const createReaction = async (id: string, data: ReactionEvent) => {
  return await wrapCall({
    method: callPut,
    uri: `/events/${id}/reactions`,
    data: { reaction: data }
  })
}

// Deletes a message
export const deleteEvent = async (id: string) => {
  return await wrapCall({
    method: callDelete,
    uri: `/events/${id}`
  })
}
